import { CATEGORIES } from '@app/src/config/categories';
import { CategoryDTO } from '@app/src/views/Home/listProducts/dto/CategoryDTO';
import { CategoryModel } from '@app/src/views/Home/listProducts';

export const hydrateData = (data: CategoryDTO[]): CategoryModel[] => {
  let newData = data.map( categorie => ({
    id: categorie.id,
    alias: categorie.alias,
    text: categorie.name,
    price: categorie.description,
    icon: CATEGORIES[categorie.alias]['icon'],
    link: CATEGORIES[categorie.alias]['link'],
    active: CATEGORIES[categorie.alias]['active'],
    order: CATEGORIES[categorie.alias]['order'],
    color: CATEGORIES[categorie.alias]['color']
  }));
  return newData.sort((a,b) => {return a.order - b.order});
}
